import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthGuard } from '../../guards/auth.guard';

import { AuthService } from '../../services/auth.service';
import { AccountService } from '../../services/account.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    errMsg: string;
    email: string;
    password: string;

    constructor(private router: Router,
        private authGuard: AuthGuard,
        private authService: AuthService,
        private accountService: AccountService) { }

    ngOnInit() {
        if (this.authGuard.checkToken()) // if logged in redirect to home
            this.router.navigate(['/']);
    }

    login() {
        this.authService.login(this.email, this.password).subscribe(
            (resToken) => {
                if (resToken.success) {
                    this.authService.saveUserToken(resToken.data.token);
                    this.accountService.getAccounts().subscribe(
                        (resAcc) => {
                            this.authService.saveAccount(resAcc[0]);
                            if (resToken.data.email === 'change')
                                this.router.navigate(['/change-mail']);
                            else
                                this.router.navigate(['/']);
                        },
                        (err) => console.error(err)
                    );
                } else {
                    this.errMsg = resToken.err;
                }
            },
            (error) => this.errMsg = error
        );
    }
}
